import { isResultError } from '../types';
export class TeleserviceService {
    teleserviceAdapter;
    constructor({ teleserviceAdapter }) {
        this.teleserviceAdapter = teleserviceAdapter;
    }
    async listAideFormationTeleservices() {
        const result = await this.teleserviceAdapter.listAideFormationTeleservice();
        if (isResultError(result)) {
            throw result.error;
        }
        return result.response;
    }
    /**
     * Get teleservice from its reference
     *
     * @param reference - Reference of teleservice to fetch
     * @returns fetched teleservice
     */
    async getTeleservice(reference) {
        const result = await this.teleserviceAdapter.getTeleservice(reference);
        if (isResultError(result)) {
            throw result.error;
        }
        return result.response;
    }
    /**
     * Get teleservice from its reference and at the given version
     *
     * @param reference - Reference of teleservice to fetch
     * @param revisionDate - Version of teleservice
     * @returns fetched teleservice
     */
    async getTeleserviceAtRevision(reference, revisionDate) {
        const result = await this.teleserviceAdapter.getTeleservice(reference, revisionDate);
        if (isResultError(result)) {
            throw result.error;
        }
        return result.response;
    }
}
//# sourceMappingURL=teleservice.service.js.map